import React from 'react';

import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button/Button';
import Input from 'components/Input/Text/Input';
import awesomeFacebook from 'assets/icons/awesome-facebook.svg';
import awesomeGoogle from 'assets/icons/icons8-google.svg';
import appleLogo from 'assets/icons/apple-logo.png';
import logoRight from 'assets/icons/Icon-feather-arrow-right.svg';
import useSignUp from 'application/authentication/useSignUp';
import '../SignUp.scoped.scss';

interface Props {
  children: React.ReactNode;
  color?: string;
  text: string;
  outlined: string;
  desperate: string;
  onClick: () => void;
}

const SignUp: React.FC<Props> = () => {
  const history = useHistory();
  const { SignUp, setPassword, setRepeatPassword, error } = useSignUp();

  const { t } = useTranslation('login');

  return (
    <div className="page section sign-up-page flex">
      <div className="content flex column align-center">
        <div className="title-container">
          <div className="title">Sign Up</div>

          <div className="subtitle">
            <p>Congratulations and welcome to Schoolify! You are invited to create a account.</p>
          </div>
        </div>
        <Button
          onClick={() => SignUp('FACEBOOK')}
          style={{
            padding: '15px',
            width: '100%',
            color: '#ffff',
            backgroundColor: '#1877F2',
          }}
          social
        >
          <img
            alt="facebook-logo"
            className="social-icon small icon-prepend"
            src={awesomeFacebook}
          />
          Register with Facebook
        </Button>
        <div className="vertical-separator" />
        <Button
          onClick={() => SignUp('GOOGLE')}
          style={{ padding: '15px', width: '100%' }}
          desperate
          social
        >
          <img alt="google-logo" className="social-icon small icon-prepend" src={awesomeGoogle} />
          Register with Google
        </Button>
        <div className="vertical-separator" />
        <Button
          onClick={() => SignUp('APPLE')}
          style={{
            padding: '15px',
            width: '100%',
            color: '#ffff',
            backgroundColor: '#000000',
            border: '1px solid #848484',
          }}
          social
        >
          <img alt="apple-logo" className="social-icon small icon-prepend" src={appleLogo} />
          Register with Apple
        </Button>
        <div className="or-separator w-100">
          <div className="left-line" />
          <p className="separator-text">Or create a password manually</p>
          <div className="right-line" />
        </div>
        <Input
          desperate
          placeholder={t('Enter your password')}
          label={t('Password')}
          onChange={setPassword}
          type="password"
        />
        <div className="vertical-separator" />
        <div className="vertical-separator" />
        <Input
          placeholder="Repeat password"
          label="Repeat password"
          grey
          onChange={setRepeatPassword}
          type="password"
        />
        {error && (
          <p className="error" style={{ paddingTop: '10px' }}>
            {error}
          </p>
        )}
        <div className="down-buttons flex w-100 justify-between ">
          <Button
            onClick={() => history.push('/')}
            outlined
            style={{
              width: '45%',
              minHeight: '45px',
              border: '2px solid #213960',
              borderRadius: '23px',
              opacity: '0.5',
            }}
          >
            Cancel
          </Button>
          <Button
            icon
            onClick={() => SignUp('PASSWORD')}
            style={{
              width: '45%',
              minHeight: '45px',
              background: '#5CD79E',
              borderRadius: '23px',
              color: '#ffff',
            }}
          >
            Next
            <img alt="next-icon" className="small" src={logoRight} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
